
import {userApi} from './user'


export const getUserSliceApi = userApi.injectEndpoints({
  endpoints: (builder) => ({
    getUserSlice: builder.query({
      query: ( fields) => `/slice?fields=${fields}`,
      
    }),
    

  }),
  overrideExisting: false,
})

export const { useGetUserSliceQuery, usePrefetch } = getUserSliceApi